module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "ch001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-001"
    }
  }, [_vm._v("CHAPTER 1")])]), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-001"
    }
  }, [_vm._v("Introduction: Water from Sinai")])]), _vm._v(" "), _c('p', {
    staticClass: "CP"
  }, [_vm._v("listen: there is a hell of a good universe next door; let’s go")]), _vm._v(" "), _c('p', {
    staticClass: "CC"
  }, [_vm._v("e. e. cummings, “pity this monster, mankind”")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_vm._v("The quotation from e. e. cummings ends a poem that protests the way modern society defines itself. The stories of Israel’s desert wanderings also portray a people in a crisis of self-definition. Time and again, they confront the harshness of life in the desert with complaints and regrets: “If only we had never left Egypt!” (e.g., Exod 15:24; Num 14:1–4). The issue comes to a head in Exod 17:1–7, when Moses strikes a mountainside to give water to his thirsty people at the behest of Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HWH")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "grey-box",
    attrs: {
      "id": "ins01"
    }
  }, [_c('p', {
    staticClass: "TABLE-H1"
  }, [_c('b', [_vm._v("How This Book Refers to God")])]), _vm._v(" "), _c('p', {
    staticClass: "Table-Bodyflush"
  }, [_vm._v("This book uses two terms to refer to the biblical divinity: God and Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HWH")]), _vm._v(". References to God use gender-neutral language whenever possible. For references to Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HWH")]), _vm._v(", Hebrew usage takes precedence; the personal name of Israel’s deity is a masculine noun.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("The account in Exodus 17 contains irony, however. The stories about Israel complaining in the desert were written with an eye to the impending revelation of Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HWH")]), _vm._v("’s "), _c('i', [_vm._v("torah")]), _vm._v(" (covenant instructions)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1",
      "id": "fn1"
    }
  }, [_vm._v("1")])]), _vm._v(" Notice where God tells Moses to stand to strike the rock:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" said to Moses, “Go on ahead of the people, and take some of the elders of Israel with you; take in your hand the staff with which you struck the Nile, and go. I will be standing there in front of you on the rock at Horeb. Strike the rock, and water will come out of it, so that the people may drink.” (Exod 17:5–6)")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Horeb is one of the names the Bible gives to the mountain where tradition says God revealed "), _c('i', [_vm._v("torah")]), _vm._v(" to Israel. As Exodus 17 begins, the people are literally camping on the backside of the mountain of God. There, on the other side of the mountain, divine instruction will constitute forms of social organization that Walter Brueggemann calls “the alternative community of Moses.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn2",
      "id": "fn2"
    }
  }, [_vm._v("2")]), _vm._v(" On Mount Sinai/Horeb, Israel will be given a new sense of self.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In Jewish tradition, water became a symbol for "), _c('i', [_vm._v("torah")]), _vm._v(". Exodus 17 hints that Israel was unaware of the kind of water it really needed. All the people could imagine is life as it had been for them; all they knew was Egypt. They didn’t understand that when they left Egypt they would be changing the very way they defined themselves. While they camp on the backside of Mount Sinai, Israel is unaware that there is an amazing universe just next door!")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The story in Exod 17:1–7 provides a parable for the way biblical law is often ignored in Christian churches. The problem can be illustrated with reference to the Revised Common Lectionary, a liturgical resource used by many denominations. The following is a list of the readings from Exodus–Deuteronomy the lectionary recommends over a three-year cycle:")]), _vm._v(" "), _c('div', {
    staticClass: "grey-box",
    attrs: {
      "id": "ins02"
    }
  }, [_c('p', {
    staticClass: "TABLE-H1"
  }, [_c('b', [_vm._v("Readings from the Revised Common Lectionary")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn3",
      "id": "fn3"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Exod")]), _vm._v(" "), _c('td', [_vm._v("1:8–2:10")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("16:2–15")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("3:1–15")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("16:2–4, 9–15")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("12:1–4 (5–10), 11–14")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("17:1–7")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("14:10–31; 15:20–21")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("19:2–8a")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("14:19–31")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("20:1–17")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("15:1b–11, 20–21")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("20:1–4, 7–9, 12–20")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("15:1b–13, 17–18")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("24:12–18")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Exod")])]), _vm._v(" "), _c('td', [_vm._v("32:1–14")]), _vm._v(" "), _c('td', [_vm._v("Deut")]), _vm._v(" "), _c('td', [_vm._v("4:1–2, 6–9")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("32:7–14")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("5:12–15")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("32:12–23")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("6:1–9")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("33:12–23")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("8:7–18")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("34:29–35")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("11:18–21, 26–28")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Lev")]), _vm._v(" "), _c('td', [_vm._v("19:1–2, 9–18")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("18:15–20")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("19:1–2, 15–18")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("26:1–11")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Num")]), _vm._v(" "), _c('td', [_vm._v("6:22–27")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("30:9–14")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("11:4–6, 10–16, 24–29")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("30:15–20")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("11:24–30")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("34:1–12")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Evidently, there is nothing of value in Leviticus except the well-known “love your neighbor as yourself.” Also, it is apparently sufficient to read the Ten Commandments while most of the other legal traditions in Exodus and Deuteronomy are overlooked. Numbers, we see, is only good for mining a few choice pieces of narrative.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Of course the contents of biblical law can pose significant hermeneutical (interpretative) challenges to contemporary readers. Women’s rights, queer sexuality, and religious pluralism (to name just a few “hot-button” issues) are important concerns that seem to be ignored or challenged in the Bible’s legal discourses. Nevertheless, when readers confine themselves to the narratives of Exodus–Deuteronomy, they are missing the possibility of entering an amazing universe—just next door. Something life-sustaining and nourishing still flows from ancient Israel’s legal literature. Hence the subtitle of this chapter: "), _c('i', [_vm._v("Water from Sinai")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("Approaching Biblical Law")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This book focuses on the law collections in the Bible for several reasons. First, many theology students are less familiar with the law in the Pentateuch than with its narratives. This book is an attempt to redress that imbalance. Second, collections of biblical law deserve to be studied as a meaningful genre of biblical literature. Just as important, law represents a significant way in which ancient Israel did theology."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn4",
      "id": "fn4"
    }
  }, [_vm._v("4")])]), _vm._v(" The legal collections surveyed in this "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("textbook articulate visions of a human community that can respond to the divine reality with integrity.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The major collections of biblical law are found in the first five books of the Bible. Jewish tradition thinks of Genesis, Exodus, Leviticus, Numbers, and Deuteronomy as the Torah "), _c('i', [_vm._v("par excellence")]), _vm._v(". As a synonym for Torah this book uses the word “Pentateuch,” a traditional term derived from ancient Greek meaning “the fivefold book.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The writings in the Pentateuch are the spiritual patrimony of both Jews and Christians. It is important, therefore, to find terms that recognize their canonical status in the scriptural traditions of both Judaism and Christianity. This book uses the term “Tanakh” as a synonym for the Old Testament. Jewish usage often refers to this body of sacred writings by an acronym formed from the words that describe its three major literary divisions: "), _c('i', [_vm._v("Tôrâ")]), _vm._v(" (Torah), "), _c('i', [_vm._v("Nәbî"), _c('span', {
    staticClass: "transI"
  }, [_vm._v("ʾ")]), _vm._v("îm")]), _vm._v(" (Prophets), and "), _c('i', [_vm._v("Kәtûbîm")]), _vm._v(" (Writings), thus Tanakh.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("A reminder of the status of the Torah or Pentateuch as Scripture in both Christianity and Judaism points to an emphasis of this introductory text. It is interested in introducing the major collections of biblical law as efforts at self-definition. At Sinai, Israel received its identity as the people of God; yet the identity that Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HWH")]), _vm._v(" graciously bestows on his people is also a vocation. This observation is not new;"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn5",
      "id": "fn5"
    }
  }, [_vm._v("5")]), _vm._v(" but it underscores one of the primary interests of legal discourse in the Old Testament. Indeed, it would not go too far to claim that underlying the intent of biblical law is the desire for incarnation: to embody the spirit of God in human community.")]), _vm._v(" "), _c('div', {
    staticClass: "grey-box",
    attrs: {
      "id": "ins03"
    }
  }, [_c('p', {
    staticClass: "TABLE-H1"
  }, [_c('b', [_vm._v("Meanings of “Israel”")])]), _vm._v(" "), _c('p', {
    staticClass: "Table-Bodyflush"
  }, [_vm._v("The word “Israel” can have three different points of reference:")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Geographical: as a name for a region of land in the Middle East")]), _vm._v(" "), _c('li', [_vm._v("Political: as a name for an ancient kingdom and a modern state")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Religious: a name for a faith community that has had various configurations over time")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "Table-Bodyflush"
  }, [_vm._v("Although all three reference points have their value, when this book uses “Israel” without qualification, it usually has a religious connotation.")])])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('p', {
    staticClass: "Body1"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("My perspective is connected to an exegetical method known as canonical criticism. It has been influenced by observations that James Sanders has made about the dynamics that brought individual books and traditions into the standardized (canonical) form called Scripture. These include claims that:"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn6",
      "id": "fn6"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Canon and community are inextricably bound.")]), _vm._v(" "), _c('li', [_vm._v("Scripture contains a plurality of voices.")]), _vm._v(" "), _c('li', [_vm._v("Scripture allows for both community stability and adaptability.")]), _vm._v(" "), _c('li', [_vm._v("The underlying purpose of Scripture is to enable communities to "), _c('i', [_vm._v("monotheize")]), _vm._v(" in a particular time and place.")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("These perspectives provide valuable ways to understand what is going on in biblical law:")]), _vm._v(" "), _c('p', {
    staticClass: "LN-FIRST"
  }, [_vm._v("1) Canonical criticism makes the claim that there is a reciprocal relationship between the written standards called Scripture and the community that knows itself through them. When we read a collection of biblical law we can ask ourselves, “How does this collection of instructions convey a vision of community, of collective self-definition?”")]), _vm._v(" "), _c('p', {
    staticClass: "LN-MIDDLE"
  }, [_vm._v("2) In this book, we will discover that the social and theological perspectives that motivated the composition of the Covenant Code (Exod 20:22–23:19), collections of Priestly instruction, and the laws of Deuteronomy are formed around different metaphors for the character of the community. A remarkable feature about the Pentateuch is that these differing perspectives are allowed to stand side by side. To some degree, of course, they have also blended with each other. This can be seen, "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("e.g., in what appears to be Priestly editing of one version of the Ten Commandments (Exod 20:11; cf. Deut 5:15). Nevertheless, these voices resolve themselves into different social metaphors out of which the Mosaic tradition is expressed. What might it mean that the Bible allows a plurality of voices in its legal collections?")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "LN-MIDDLE"
  }, [_vm._v("3) Collections of biblical law are capable of revising and, in some cases, challenging other perspectives now found in the canon. In fact, biblical law negotiates the need for both "), _c('i', [_vm._v("stability")]), _vm._v(" in the communities that know themselves in relationship to the Mosaic tradition and "), _c('i', [_vm._v("adaptability.")]), _vm._v(" Differing perspectives and different historical contexts dictate not only the preservation of past traditions but also their modification.")])]), _c('p', {
    staticClass: "LN-LAST"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("4) Fidelity to the Mosaic tradition required Israel’s thinkers to "), _c('i', [_vm._v("monotheize")]), _vm._v(". According to Sanders, the human tendency is to compartmentalize, to let God have sovereignty over some of life but to leave other parts open to the domination of other powers/deities. Israel’s thinkers were constrained, however, to bring all of their experiences of life under the purview of Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HWH")]), _vm._v("."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn7",
      "id": "fn7"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("One of the inferences of this book’s approach is that biblical law represents a dynamic system of thought. It is capable of both innovation and conservatism, of stabilizing a religious community while also helping it adapt to new cultural exigencies. Modern readers of the Old Testament, no less than ancient ones, have to negotiate the tension between finding stability with tradition and adapting to new and often unprecedented situations.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is my opinion that the dynamism which generated collections of biblical law can also energize contemporary communities of faith. Nevertheless, this book stops short of telling modern readers what to derive from encountering the community-making tactics of biblical law. As one might expect, contemporary attitudes vary significantly with regard to the relevance of the collections of rules and rituals this book seeks to introduce. Some would assert that the Bible’s criminal law remains completely applicable to the modern state."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn8",
      "id": "fn8"
    }
  }, [_vm._v("8")])]), _vm._v(" Others want to privilege key texts such as the Ten Commandments, while ignoring most of the rest. There has also been extensive debate about the continuing relevance of biblical law to debates "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("about capital punishment, gender roles, and environmental ethics—to name only a few prominent examples."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn9",
      "id": "fn9"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As important as these discussions are, this book will not engage with them directly. Rather, it seeks to prepare the groundwork for contemporary interactions with biblical law by asking about the concept of community that a given law collection promotes or assumes. What might such visions mean for contemporary faith communities seeking to know themselves as heirs of the Mosaic tradition? A particular goal is that this book will be useful to students in seminaries and lay people in the church. Therefore, many chapters of this "), _c('i', [_vm._v("Introduction to Biblical Law")]), _vm._v(" inquire about the fate or development of the Torah’s legal traditions in New Testament times. These discussions can be found at the end of chapters 5–22 under the heading “Developments.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Obviously, there are hazards in writing on developments in the first century CE (Common Era)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn10",
      "id": "fn10"
    }
  }, [_vm._v("10")])]), _vm._v(" In many cases, interactions with the legal patrimony of the Pentateuch at the beginning of the Common Era deserve their own full, book-length discussions. Even so, the analyses are kept brief in order to keep attention fixed on interpretation of the biblical law collections themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Another risk of mentioning first-century CE developments is that these discussions might play into the hands of Christian inclinations towards “supersessionism,” a doctrine that contends Christianity has superseded Judaism as the legitimate heir of the biblical tradition. As a guard against the rhetoric of supersessionism, this book refers to the Scriptures shared between church and synagogue as the Tanakh as well as the Old Testament.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A further emphasis is that the first Christians thought of themselves as Jews. This is not to claim that Jewish self-definition in the first century CE was monolithic. On the contrary, this historical era was one of extraordinary creativity."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn11",
      "id": "fn11"
    }
  }, [_vm._v("11")])]), _vm._v(" The early church emerged at the time when a number of Jewish groups were actively addressing problems of adaptation and stability as the "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("people of Israel. Among its rivals and coreligionists were the protorabbinic movement (represented, e.g., by the Pharisees) and the Dead Sea Scroll sect at Qumran. All of these groups lived in substantial dialogue with the spirituality and community-making tactics of biblical law, even as they sought to create viable expressions of the Mosaic tradition for their own time. The sections on “Developments” seek to demonstrate that those who created the early church were making Jewish choices—not necessarily ones that led to normative Judaism, but Jewish in inspiration nonetheless."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn12",
      "id": "fn12"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("What This Book Is Not")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This book is not a comprehensive introduction to biblical law. It is illustrative but not exhaustive. Some excellent surveys of biblical law are available that are quite technical and thorough; this book will not duplicate their efforts."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn13",
      "id": "fn13"
    }
  }, [_vm._v("13")])]), _vm._v(" At the end of each part I provide a reading list of some of the more major works on each specific subject, and at the end of the book I provide a select bibliography of more general surveys of biblical law and books exploring biblical law and religion. Those seeking a comprehensive guide to scholarship in biblical law should consult John Welch’s “Biblical Law Cumulative Bibliography.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn14",
      "id": "fn14"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In fact, a variety of specialized kinds of learning are required to fully study collections of biblical law. Many of these approaches will be used in the following chapters; but readers wanting to be fully informed by them will have to look elsewhere. These disciplines include:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("familiarity with the literary forms and techniques used by ancient scribes;")]), _vm._v(" "), _c('li', [_vm._v("a knowledge of legal process and legal history;")]), _vm._v(" "), _c('li', [_vm._v("expertise in the literatures of surrounding cultures, especially texts from ancient Mesopotamia;")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("the history and archaeology of the societies mentioned in the Bible;")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('li', [_vm._v("the use and interpretation of biblical law in postbiblical times;")]), _vm._v(" "), _c('li', [_vm._v("the ability to appropriate biblical scholarship in a number of modern languages.")])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The last point in this list bears special attention. The literature devoted to the study of biblical law is extensive and it has been produced by scholars in many different countries. As this textbook has been written with an English-speaking audience in mind, most of its references are in English. Nevertheless, readers will find a representative number of references in French, German, and Modern Hebrew. While important in their own right, these notes also signal a significant dimension of the study of biblical law. Students hoping to specialize in this field need to recognize that many important studies are not translated into English.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("This book is not an exegetical handbook. Careful study of a text through close readings of its structure, form, historical background, etc. reward the reader with significant insights into a passage’s meaning. Close reading involves, therefore, what scholars refer to as “exegetical method.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn15",
      "id": "fn15"
    }
  }, [_vm._v("15")]), _vm._v(" While various exegetical operations will be used in this book, its interest lies elsewhere than laying out a full methodology for the interpretation of biblical law.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Finally, this book is not intended to be a history of biblical law. Of necessity, students ought to be aware of some of the problems and solutions available to account for the development of a particular legal collection into its canonical form. These are briefly surveyed in the introductions to each of the law collections this book discusses. It is hoped that some students will be inspired by these short surveys to undertake the specialized training and research needed to address problems involved in the historical development of the Bible’s legal traditions in depth.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("What This Book Is")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Central to this book is the idea that what is conventionally called “biblical law” is not a monolith but is made up of various voices or perspectives. The "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("sections that follow will describe four different social contexts out of which biblical law was articulated:"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn16",
      "id": "fn16"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Israel at the holy mountain (Chapters 5–6). These chapters deal with the Ten Commandments.")]), _vm._v(" "), _c('li', [_vm._v("Israel in the village assembly (Chapters 7–9). These chapters discuss the laws in Exod 20:22–23:19.")]), _vm._v(" "), _c('li', [_vm._v("Israel in the courts of the Lord (Chapters 10–17). Here, Priestly and Holiness law found in Exodus, Leviticus, and Numbers are examined.")]), _vm._v(" "), _c('li', [_vm._v("Law in the city (Chapters 18–22). The focus of these chapters is on the book of Deuteronomy.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Each of these four sections contains an introductory chapter followed by studies of representative laws in order to portray their community-making dynamics at work. In describing them, the discussion will not shy away from controversy. The Torah’s law collections touch on themes such as slavery, revenge, sacrifice, ritual purity, gender inequality, and religious intolerance. Although this book intends to read biblical law sympathetically, it will not explain away material that may offend or puzzle modern sensibilities. Rather, it seeks to understand the witness of these instructions and regulations in an effort to make a viable community of faith.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The book begins with methodological considerations relevant to reading legal material. Chapters 2–4 introduce students to aspects important in approaching the study of biblical law.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Since historical references are important, Chapter 2 sets out basic terminology related to biblical history.")]), _vm._v(" "), _c('li', [_vm._v("Chapter 3 addresses important questions about the relationship between the meaning of Moses as a mediator of Israel’s legal traditions and the Moses of history. It will become clear that all of the collections of biblical law studied here owe their canonical form to processes of Scripture formation which came to fruition in the Persian period, perhaps 750–950 years after the time of the Exodus. What can it possibly mean to refer to Mosaic law under such circumstances?")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("Chapter 4 describes various approaches that biblical scholars have employed to investigate biblical law. This includes different kinds of legal theory, comparative approaches drawing on the literature of the ancient Near East, and the study of law as literature.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Beginning with Chapter 5, the book examines the community-making dynamics of biblical law using the perspectives listed above. A summary chapter concludes the book.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("Verse References and Translation")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The standard edition of the Old Testament in Hebrew is called the Masoretic Text (MT). Occasionally, the chapter and verse divisions of MT differ from the tradition used in most English translations. For example, Exod 21:37 in the MT is Exod 22:1 in the New Revised Standard Version (NRSV). In these cases, verse references follow the tradition used in the NRSV. Readers familiar with the Hebrew will be able to make the necessary adjustments. Unless otherwise noted, biblical translations follow the NRSV.")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('img', {
    attrs: {
      "alt": "line",
      "src": "images/line1.jpg"
    }
  })])]), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn1"
    }
  }, [_vm._v("1")]), _vm._v(". "), _c('i', [_vm._v("Torah")]), _vm._v(" is a transliteration of a Hebrew word that has rich meanings in Judaism. While it originally meant “instruction” or “teaching,” "), _c('i', [_vm._v("torah")]), _vm._v(" came to mean the sum total of teachings that stem from Israel’s encounter with God.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn2"
    }
  }, [_vm._v("2")]), _vm._v(". Walter Brueggemann, "), _c('i', [_vm._v("The Prophetic Imagination")]), _vm._v(", 2nd ed. (Minneapolis: Fortress, 2001), 1–19.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn3"
    }
  }, [_vm._v("3")]), _vm._v(". “The Revised Common Lectionary,” Vanderbilt Divinity Library. "), _c('a', {
    attrs: {
      "href": "http://lectionary.library.vanderbilt.edu/",
      "target": "_blank"
    }
  }, [_vm._v("http://lectionary.library.vanderbilt.edu/")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn4"
    }
  }, [_vm._v("4")]), _vm._v(". This claim is more contentious than it may appear, as biblical scholarship has wrestled with the question about whether it is legitimate to read the writings of the Old Testament as expressions of what the contemporary church has come to think of as theology. My claim finds justification not only in the attempts by past generations to write theologies of the Old Testament but also in recent studies such as that of Konrad Schmid, "), _c('i', [_vm._v("Is There Theology in the Hebrew Bible?")]), _vm._v(" (Critical Studies in the Hebrew Bible 4; Winona Lake: Eisenbrauns, 2015), 114–19.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn5"
    }
  }, [_vm._v("5")]), _vm._v(". See, e.g., Walter Zimmerli, "), _c('i', [_vm._v("Old Testament Theology in Outline")]), _vm._v(" (Atlanta: John Knox, 1978), 109; Dale Patrick, "), _c('i', [_vm._v("The Rhetoric of Revelation in the Hebrew Bible")]), _vm._v(" (OBT; Minneapolis: Fortress, 1999), 80.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn6"
    }
  }, [_vm._v("6")]), _vm._v(". This list is mine. It is based on James A. Sanders, “The Bible as Canon,” "), _c('i', [_vm._v("ChrCent")]), _vm._v(" 98 (2 December 1981): 1250–55; "), _c('i', [_vm._v("Canon and Community: A Guide to Canonical Criticism")]), _vm._v(" (GBS; Philadelphia: Fortress, 1984); and "), _c('i', [_vm._v("From Sacred Story to Sacred Text: Canon as Paradigm")]), _vm._v(" (Philadelphia: Fortress, 1987).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn7"
    }
  }, [_vm._v("7")]), _vm._v(". Sanders, “The Bible as Canon,” 1255.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn8"
    }
  }, [_vm._v("8")]), _vm._v(". E.g., the “dominion theology” movement represented by R. J. Rushdoony, "), _c('i', [_vm._v("The Institutes of Biblical Law")]), _vm._v(", vol. 1 (Phillipsburg: P & R, 1973).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn9"
    }
  }, [_vm._v("9")]), _vm._v(". See, e.g., the discussions on the continuing relevance of biblical law in Joe M. Sprinkle, "), _c('i', [_vm._v("Biblical Law and Its Relevance: A Christian Understanding and Ethical Application for Today of the Mosaic Regulations")]), _vm._v(" (Lanham: University Press of America, 2006); Cheryl B. Anderson, "), _c('i', [_vm._v("Ancient Laws & Contemporary Controversies: The Need for Inclusive Biblical Interpretation (")]), _vm._v("New York: Oxford University Press, 2009); and Richard E. Friedman and Shawna Dolansky, "), _c('i', [_vm._v("The Bible Now")]), _vm._v(" (New York: Oxford University Press, 2011).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn10"
    }
  }, [_vm._v("10")]), _vm._v(". Current biblical scholarship frequently uses the abbreviations BCE (“before the Common Era”) and CE (“Common Era”) to be more inclusive of Jewish perspectives, rather than BC (“before Christ”) and AD (for "), _c('i', [_vm._v("anno domini")]), _vm._v(", “the year of our Lord”)"), _c('i', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn11"
    }
  }, [_vm._v("11")]), _vm._v(". Donald H. Akenson, "), _c('i', [_vm._v("Surpassing Wonder: The Invention of the Bible and the Talmuds")]), _vm._v(" (Montreal: McGill-Queen’s, 1998), 107–207.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn12"
    }
  }, [_vm._v("12")]), _vm._v(". For descriptions of how New Testament writers were engaged with their Jewish heritage and thought patterns, see "), _c('i', [_vm._v("The Jewish Annotated New Testament")]), _vm._v(", edited by Amy-Jill Levine and Marc Zvi Brettler (New York: Oxford University Press, 2011).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn13"
    }
  }, [_vm._v("13")]), _vm._v(". Brent Strawn, ed., "), _c('i', [_vm._v("The Oxford Encyclopedia of Bible and Law")]), _vm._v(" (New York: Oxford University Press, 2015); Pamela Barmash, ed., "), _c('i', [_vm._v("The Oxford Handbook of Biblical Law")]), _vm._v(" (New York: Oxford University Press, 2017).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn14"
    }
  }, [_vm._v("14")]), _vm._v(". “Biblical Law Cumulative Bibliography.” The Ancient World Online: Institute for the Study of the Ancient World, 2014.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn15"
    }
  }, [_vm._v("15")]), _vm._v(". A number of books introduce exegetical method for biblical study, e.g., John H. Hayes and Carl A. Holladay, "), _c('i', [_vm._v("Biblical Exegesis: A Beginner’s Handbook")]), _vm._v(", 3rd ed. (Louisville: Westminster John Knox, 2007); Michael Gorman, "), _c('i', [_vm._v("Elements of Biblical Exegesis: A Basic Guide for Students and Ministers")]), _vm._v(", rev. ed. (Peabody, MA: Hendrickson, 2008); Douglas Stuart, "), _c('i', [_vm._v("Old Testament Exegesis: A Handbook for Students and Pastors")]), _vm._v(", 4th ed. (Louisville: Westminster John Knox, 2009).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn16"
    }
  }, [_vm._v("16")]), _vm._v(". In his work on the ideology of biblical law, Douglas Knight ("), _c('i', [_vm._v("Law, Power, and Justice in Ancient Israel")]), _vm._v(" [LAI; Louisville: Westminster John Knox, 2011], 4) identified three perspectives that characterize different collections of biblical law: a village perspective (the Covenant Code), a temple-centered perspective (Priestly law), and a nationalist perspective (found in Deuteronomy). This textbook both reflects Knight’s social distinctions and modifies them.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9d0f694","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter001.vue
// module id = 81
// module chunks = 0